export const relatedProductsGql = /* GraphQL */ `
  ... on landingPageContent2023_lp2RelatedProducts_BlockType {
    typeHandle
    displayViewAllLink
    displayFilters
    filterCategoryDepth
    relatedProducts: lp2RelatedProducts {
      ... on product_productPage2022_Entry {
        uri
        title
        relatedProductDescription
        relatedProductTitle

        productCategories(orderBy: "lft asc") {
          id
          level
          categoryTitle: title
          url
        }

        productFeaturedImage {
          ... on images_Asset {
            title
            galleryEnlarged {
              srcWebp
              srcset
            }
          }
          ... on productImages_Asset {
            title
            galleryEnlarged {
              srcWebp
              srcset
            }
          }
        }
      }

      ... on product_productPage_Entry {
        uri
        title
        relatedProductDescription
        relatedProductTitle

        productCategories(orderBy: "lft asc") {
          id
          level
          categoryTitle: title
          url
        }

        productFeaturedImage {
          ... on images_Asset {
            title
            galleryEnlarged {
              srcWebp
              srcset
            }
          }
          ... on productImages_Asset {
            title
            galleryEnlarged {
              srcWebp
              srcset
            }
          }
        }
      }
    }
  }
`;
